import React from 'react';
import { Tooltip, CircularProgress, IconButton } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import RefreshIcon from '@material-ui/icons/Refresh';
import SaveIcon from '@material-ui/icons/Save';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

export default function CustomToolbar({ eventHandlers, isTableDataLoading, hideActionButtons }) {
  hideActionButtons = hideActionButtons || false;
  const hasAddEvent = eventHandlers.handleSidePanel && typeof eventHandlers.handleSidePanel === 'function';
  const hasUpdateEvent = eventHandlers.handleUpdateEvent && typeof eventHandlers.handleUpdateEvent === 'function';
  const hasImportEvent = eventHandlers.handleImportEvent && typeof eventHandlers.handleImportEvent === 'function';
  return (
    <React.Fragment>
      {!hideActionButtons && hasAddEvent && (
        <div className="table-custom-actions">
          <IconButton onClick={() => eventHandlers.handleSidePanel(true)}>
            <AddCircleIcon /> <span className="table-action-text">{eventHandlers.addButtonText}</span>
          </IconButton>
        </div>
      )}
      {!hideActionButtons && hasUpdateEvent && (
        <div className="table-custom-actions">
          <IconButton onClick={() => eventHandlers.handleUpdateEvent()}>
            <SaveIcon /> <span className="table-action-text">{eventHandlers.updateButtonText}</span>
          </IconButton>
        </div>
      )}
      {!hideActionButtons && hasImportEvent && (
        <div className="table-custom-actions">
          <IconButton onClick={() => eventHandlers.handleImportEvent(true)}>
            <AddCircleOutlineIcon /> <span className="table-action-text">{eventHandlers.importButtonText}</span>
          </IconButton>
        </div>
      )}
      {isTableDataLoading && (
        <IconButton style={{ order: 10 }}>
          <CircularProgress size={18} />
        </IconButton>
      )}
      {!isTableDataLoading && (
        <Tooltip title={'Refresh'}>
          <IconButton style={{ order: 10 }} onClick={eventHandlers.refreshTable}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      )}
    </React.Fragment>
  );
}
